import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-seach-module',
  templateUrl: './seach-module.component.html',
  styleUrls: ['./seach-module.component.css']
})
export class SeachModuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
